import React, { createContext, useState, useEffect, useContext } from "react"
import Cookies from "js-cookie"

const UserContext = createContext()

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(Cookies.get("user") || "null")
    } catch {
      return null
    }
  })

  const [token, setToken] = useState(() => Cookies.get("token") || null)

  useEffect(() => {
    const getUserFromCookies = () => {
      const userData = Cookies.get("user")
      const token = Cookies.get("token")
      let parsedUser = null
      let parsedToken = null

      if (userData) {
        try {
          parsedUser = JSON.parse(userData)
        } catch (e) {
          console.error("Failed to parse user data:", e)
        }
      }

      if (token) {
        parsedToken = token
      }

      setUser(parsedUser)
      setToken(parsedToken)
    }

    getUserFromCookies()
  }, [])

  const updatedSetUser = newUser => {
    setUser(newUser)
    Cookies.set("user", JSON.stringify(newUser), {
      expires: 1,
      secure: true,
    })
  }

  const updatedSetToken = newToken => {
    setToken(newToken)
    Cookies.set("token", newToken, { expires: 1, secure: true })
  }

  // Logout function implementation
  const logout = () => {
    setUser(null)
    setToken(null)
    Cookies.remove("user")
    Cookies.remove("token")
    window.location.href = "/"
  }

  return (
    <UserContext.Provider
      value={{
        user,
        setUser: updatedSetUser,
        token,
        setToken: updatedSetToken,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => useContext(UserContext)
